import { createApp } from 'vue';
import App from './App.vue';
import router from './router'; // 引入路由配置
// import VueRouter from 'vue-router';
import axios from './utils/request';

const app = createApp(App)
.use(router) // 使用路由

app.provide("axios", axios); // 通过依赖注入使用
app.config.globalProperties.$http = axios;
app.mount('#app');